document.querySelectorAll('.marquee__v2--slider').forEach(function(el) {
  new Swiper(el, {
    slidesPerView: "auto",
    spaceBetween: 30,
    loop: true,
    loopedSlides: 20, // Make sure to have enough slides
    allowTouchMove: false,
    grabCursor: false,
    freeMode: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
    speed: 20000,
    breakpoints: {
      550: {
        slidesPerView: "auto",
        spaceBetween: 50
      },
      768: {
        slidesPerView: "auto",
        spaceBetween: 60
      },
      972: {
        slidesPerView: "auto",
        spaceBetween: 80
      }
    }
  });
});
